import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as actions from '../../actions';
import Category from "./category";
import {toJS} from "../hocs/toJs";

const parsePillars = (pillars) => {
  const parsedPillars = [];
  pillars.valueSeq().toArray().forEach(pillar => {
    parsedPillars.push({
      id: pillar.get('id'),
      name: pillar.get('name'),
    })
  });
  return parsedPillars;
};

const parseCategory = (category) => {
  return {
    id: category.get('name'),
    name: category.get('name'),
    weightOld: category.get('weightOld'),
    weightNew: category.get('weightNew'),
    weightNewComing: category.get('weightNewComing'),
    createdDate: category.get('pillar'),
    pillarId:  category.get('pillarId'),
  }
};

class CategoryHOC extends Component {

  componentDidMount(){
    this.props.getPillars({filter:{where: {or: [{deleted: false}, {deleted: null}]}}});
    if(this.props.match.params.id){
      this.props.getCategoryById({id:this.props.match.params.id})
    }
  }

  parseForm = (formIM) => {
    return {
      name: formIM.get('name'),
      weightOld: formIM.get('weightOld'),
      weightNew: formIM.get('weightNew'),
      weightNewComing: formIM.get('weightNewComing'),
      createdDate: new Date(),
      pillarId:  formIM.get('pillarId'),
    }
  };

  submitCategory = (formIM) => {
    const form = this.parseForm(formIM);

    if(this.props.match.params.id){
      delete form.createdDate;
      this.props.updateCategory({
        id:this.props.match.params.id,
        sendBody: form
      })
    } else {
      this.props.createCategory({sendBody: form});
    }
  };

  render(){
    return (
      <Category
        {...this.props}
        submitCategory={this.submitCategory}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    pillars: state.pillars.get('pillars'),
    category: state.category.get('category'),
    message: state.category.get('message'),
    loading: state.category.get('fetching') || state.category.get('posting') || state.category.get('updating')
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    createCategory: (payload) => {
      dispatch(actions.createCategory(payload))
    },
    getPillars: (payload) => {
      dispatch(actions.getPillars(payload))
    },
    getCategoryById: (payload) => {
      dispatch(actions.getCategoryById(payload))
    },
    updateCategory: (payload) => {
      dispatch(actions.updateCategory(payload))
    },
    changeCategoryStore: (payload) => {
      dispatch(actions.changeCategoryStore(payload))
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(toJS(CategoryHOC));



// WEBPACK FOOTER //
// ./src/components/category/categoryHOC.js